export var OBJECT_TYPE_NAMES;
(function (OBJECT_TYPE_NAMES) {
  OBJECT_TYPE_NAMES["HANDHOLE"] = "HANDHOLE";
  OBJECT_TYPE_NAMES["FIBER"] = "FIBER";
  OBJECT_TYPE_NAMES["SPLICE"] = "SPLICE";
  OBJECT_TYPE_NAMES["TASK"] = "TASK";
  OBJECT_TYPE_NAMES["COMMENT"] = "COMMENT";
  OBJECT_TYPE_NAMES["ATTACHMENT"] = "ATTACHMENT";
  OBJECT_TYPE_NAMES["REFERENCE"] = "REFERENCE";
  OBJECT_TYPE_NAMES["CUSTOMER"] = "CUSTOMER";
  OBJECT_TYPE_NAMES["BANK_ACCOUNT"] = "bank_account";
  OBJECT_TYPE_NAMES["BUDGET_ITEM"] = "budget_item";
  OBJECT_TYPE_NAMES["EXPENSE"] = "expense";
  OBJECT_TYPE_NAMES["CONDUIT"] = "conduit";
  OBJECT_TYPE_NAMES["BANK_TRANSACTION"] = "bank_transaction";
  OBJECT_TYPE_NAMES["INVOICE"] = "invoice";
  OBJECT_TYPE_NAMES["SUBSCRIPTION"] = "subscription";
  OBJECT_TYPE_NAMES["TICKET"] = "ticket";
  OBJECT_TYPE_NAMES["SERVICE_PLAN"] = "service_plan";
  OBJECT_TYPE_NAMES["PARCEL"] = "parcel";
  OBJECT_TYPE_NAMES["ASSET"] = "asset";
  OBJECT_TYPE_NAMES["CUSTOMERBALANCE"] = "customer_balance";
  OBJECT_TYPE_NAMES["PLATFORMUSERS"] = "platform-user";
})(OBJECT_TYPE_NAMES || (OBJECT_TYPE_NAMES = {}));